export * from './ajax.service';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/services/ajax/index.ts